<div class="k-overlay" *ngIf="servicesProvidedDialogOpened"></div>
<kendo-window *ngIf="servicesProvidedDialogOpened" [width]="1400" (close)="cancelServicesProvided()"
    [state]="windowState" style="position:fixed">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3>{{ (checkAccumulatorOnly ? 'CHECK-SERVICES-PROVIDED': 'SELECT-SERVICES-PROVIDED') | translate}} -
                {{'CASE-ID-NUMBER' | translate}} {{caseId}}
            </h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <form [formGroup]="servicesProvidedForm" class="k-form" (ngSubmit)="createServicesProvided()"
        style="max-height:100vh;overflow-x: auto;">
        <div class="row">
            <div class="col-3">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'DATE-OF-SERVICE' | translate}} *
                    </span>
                </label>
            </div>
            <div class="col-2">
                <kendo-datepicker class="w-100" [min]="minServiceDate" [max]="maxServiceDate"
                    formControlName="serviceDate">
                </kendo-datepicker>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="serviceDate.invalid && serviceDate.touched">
                    {{'SERVICE-DATE-REQUIRED' | translate}}
                </div>
            </div>
            <div class="col-2 mt-2">
                <div *ngIf="eligibleMember !== undefined">
                    <span *ngIf="eligibleMember" class="eligible p-2"><i
                            class="fas fa-user-check"></i>&nbsp;{{'ELIGIBLE' |
                        translate}}
                    </span>
                    <span *ngIf="eligibleMember !== undefined && !eligibleMember && !medicaidMissing"
                        class="not-eligible p-2"><i class="fas fa-user-slash"></i>&nbsp;{{'RECORD-STATUS-NOT-ELIGIBLE' |
                        translate}}
                    </span>
                    <span *ngIf="medicaidMissing" class="not-eligible p-2">{{'MEDICAID-NOT-SET' | translate}}
                    </span>
                </div>
            </div>
            <div *ngIf="checkAccumulatorOnly" class="col-5 mt-2 text-right"><span class="p-2"
                    style="background-color: #e07a1a;color: #fff;"><i
                        class="fas fa-exclamation-triangle"></i>&nbsp;{{'SERVICES-CHECK-ONLY' | translate}}</span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'SERVICES-PROVIDED' | translate}} <span *ngIf="servicesProvidedRequired()">*</span>
                    </span>
                </label>
            </div>
            <div class="col-9">
                <kendo-multiselect id="billableServices" [data]="billableServicesFiltered"
                    formControlName="billableServices" [textField]="'name'" [filterable]="true" [valueField]="'id'"
                    (filterChange)="filterBillableServices($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualServices">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}" class="ellipsis-text">
                        </span>
                    </ng-template>
                </kendo-multiselect>
                <div class="k-tooltip k-tooltip-validation mb-2" role="alert"
                    style="display:inline-block;position: static;"
                    *ngIf="billableServices.invalid && billableServices.touched">
                    {{'SERVICES-PROVIDED-REQUIRED' | translate}}
                </div>
            </div>
        </div>
        <!--Comments-->
        <div class="row mt-2">
            <div class="col-3">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'COMMENTS' | translate}}
                    </span>
                </label>
            </div>
            <div class="col-9">
                <textarea kendoTextArea rows="1" class="w-100" formControlName="comments" maxlength="10485760">
                </textarea>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <kendo-grid [data]="viewServices.gridData" [sortable]="true" [sort]="viewServices.state.sort"
                    [navigable]="true" style="max-height:300px" (cancel)="serviceCancelHandler($event)"
                    (save)="serviceSaveHandler($event)" (edit)="serviceEditHandler($event)"
                    (dataStateChange)="serviceDataStateChange($event)">
                    <kendo-grid-messages noRecords="{{ 'NO-SELECTED-SERVICES' | translate }}">
                    </kendo-grid-messages>
                    <kendo-grid-column field="name" [width]="25" title="{{ 'SERVICE-NAME' | translate }}">
                    </kendo-grid-column>
                    <kendo-grid-column field="units" title="{{ 'UNITS' | translate }}" [width]="20" class="text-right">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngIf="dataItem.informationalOnly">-</span>
                            <span *ngIf="!dataItem.informationalOnly">{{dataItem.units}}</span>
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            <div [formGroup]="serviceForm[dataItem.billableId]">
                                <kendo-numerictextbox [format]="'n0'" formControlName="units" [min]="1"
                                    style="max-width:150px">
                                </kendo-numerictextbox>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="rate" title="{{ 'RATE' | translate }}" [width]="20" [format]="'n2'"
                        *ngIf="rateLoaded" class="text-right">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngIf="dataItem.informationalOnly || dataItem.hasManualAmount">-</span>
                            <span *ngIf="!(dataItem.informationalOnly || dataItem.hasManualAmount)">{{dataItem.rate |
                                number : '1.2-2'}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="totalAmount" title="{{ 'TOTAL-AMOUNT' | translate }}" [width]="20"
                        [format]="'n2'" class="text-right">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngIf="dataItem.hasManualAmount">{{dataItem.totalAmount | number : '1.2-2'}}</span>
                            <span style="color: #dc5d3f"
                                *ngIf="dataItem.hasManualAmount && !dataItem.totalAmount && dataItem.totalAmount !== 0">
                                {{'REQUIRED' | translate}}
                            </span>
                            <span
                                *ngIf="!dataItem.hasManualAmount && !dataItem.informationalOnly">{{dataItem.totalAmount
                                | number : '1.2-2'}}</span>
                            <span *ngIf="dataItem.informationalOnly">-</span>
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            <div [ngSwitch]="dataItem.hasManualAmount">
                                <div *ngSwitchCase="true" [formGroup]="serviceForm[dataItem.billableId]">
                                    <kendo-numerictextbox [format]="'n2'" formControlName="totalAmount" [min]="0"
                                        style="max-width:150px">
                                    </kendo-numerictextbox>
                                </div>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column *ngIf="accumulatorLoaded" field="accumulatorNameSummary" [width]="30"
                        title="{{ 'ACCUMULATOR' | translate }}">
                    </kendo-grid-column>
                    <kendo-grid-column *ngIf="accumulatorLoaded" field="currentUnits" [width]="20"
                        title="{{ 'CURRENT-UNITS' | translate }}" [format]="'n0'" class="text-right">
                    </kendo-grid-column>
                    <kendo-grid-column *ngIf="accumulatorLoaded" field="currentAmount" [width]="20"
                        title="{{ 'CURRENT-AMOUNT' | translate }}" [format]="'n2'" class="text-right">
                    </kendo-grid-column>
                    <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <ng-container *ngIf="!dataItem.editing && !dataItem.informationalOnly">
                                <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                                    (click)="serviceEditButton.click.emit($event); dataItem.editing = true;"></i>
                                <button kendoGridEditCommand #serviceEditButton class="d-none"></button>
                            </ng-container>
                            <ng-container *ngIf="dataItem.editing">
                                <ng-container
                                    *ngIf="serviceForm[dataItem.billableId] !== null && serviceForm[dataItem.billableId] !== undefined && serviceForm[dataItem.billableId].valid">
                                    <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                                        (click)="serviceSaveButton.click.emit($event); dataItem.editing = false;">
                                    </i>
                                    &nbsp;
                                </ng-container>
                                <i class="fas fa-times-circle fa-lg icon-neutral pointer"
                                    title="{{'CANCEL' | translate}}"
                                    (click)="serviceCancelButton.click.emit($event); dataItem.editing = false;"></i>
                                <button kendoGridSaveCommand #serviceSaveButton class="d-none"></button>
                                <button kendoGridCancelCommand #serviceCancelButton class="d-none"></button>
                            </ng-container>
                        </ng-template>
                    </kendo-grid-command-column>
                    <ng-template kendoGridDetailTemplate [kendoGridDetailTemplateShowIf]="hasBillableDescription"
                        let-dataItem *ngIf="billableDescriptionLoaded">
                        {{dataItem.billableDescription}}
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
        <div class="row mt-3" *ngIf="accumulatorLoaded">
            <div class="row ml-3">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'ACCUMULATOR-SUMMARY' | translate}}
                    </span>
                </label>
            </div>
            <div class="row ml-3 mr-3">
                <app-accumulator-grid [dataView]="viewAccumulators" [newTitleKey]="'NEW-TOTAL'"
                    [gridMaxHeight]="'300px'" [durationLoaded]="durationLoaded">
                </app-accumulator-grid>
            </div>
        </div>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions style="position:relative;margin-left:-16px;bottom:0;height:58px" class="w-100 mt-3">
        <button kendoButton (click)="cancelServicesProvided()">{{'CANCEL' | translate}}</button>
        <button appPreventClick kendoButton (click)="createServicesProvided()" [primary]="true"
            [disabled]="servicesProvidedForm.invalid || (!servicesProvidedForm.dirty && !checkAccumulatorOnly)">
            {{'COMPLETE-TASK' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-window>